// extracted by mini-css-extract-plugin
module.exports = {"accordionElement":"AccordionElement--accordion-element--3AEs5","listElement":"AccordionElement--list-element--JtWfU"};